export enum ButtonType {
  BACK_BUTTON = 'BACK_BUTTON',
  SKIP_BUTTON = 'SKIP_BUTTON',
  ADD_MANUALY = 'ADD_MANUALY',
  UPLOAD_FILE = 'UPLOAD_FILE',
}
